module.exports = __webpack_public_path__ + "img/bonus_pc_en.310331ab.png";